import React from 'react'
import './Footer.css';

import logoANS from '../assets/ANS.png';
// import logoCornilleau from '../assets/cornilleau.png';
// import logoPongori from '../assets/pongori.png';
// import logoTibhar from '../assets/tibhar.png';
import logoCornilleau from '../assets/cornilleau_blanc.png';
import logoTibhar from '../assets/tibhar_blanc.png';
import logoGerflor from '../assets/gerflor.png';
import logoMinistere from '../assets/ministere.jpg';
// import logoNittaki from '../assets/nittaki.png';
import logoNittaki from '../assets/donic_nittaku_blanc.png';
import logoCreditMutuel from '../assets/credit_mutuel_white.png';
import leapmotor from '../assets/leapmotor_white.png';

// Icones
import {
    BsTwitterX,
    BsInstagram,
    BsYoutube
} from 'react-icons/bs';

import { FaFacebookF } from 'react-icons/fa'
import { useLocation, NavLink } from 'react-router-dom';

function Footer() {
    const location = useLocation();
    const classeLocation =  location.pathname.split('/')[1];

    const openWindow = (link) => {
        window.open(link, '_blank');
    }

    return ( 
        <div className="footer_component">
            
            <div className={"footer_socials_medias " + classeLocation}>
                <span style={{marginRight: 10}}>Suivez nous sur</span>
                <a href="https://x.com/ffttofficiel" target="_blank">
                    <BsTwitterX size={24} color='white' style={{cursor: 'pointer'}} />
                </a>
                <a href="https://www.instagram.com/ffttofficiel" target="_blank">
                    <BsInstagram size={24} color='white' style={{cursor: 'pointer'}} />
                </a>
                <a href="https://www.facebook.com/FFTTofficiel" target="_blank">
                    <FaFacebookF size={24} color='white' style={{cursor: 'pointer'}} />
                </a>
                <a href="https://www.youtube.com/channel/UC6hHKx0z0enl5RnKnrOrmfw" target="_blank">
                    <BsYoutube size={24} color='white' style={{cursor: 'pointer'}} />
                </a>
            </div>
            <div className="footer_partenaires">
                <div className="footer_partenaires_images">
                    <span className={'footer_span_partenaires ' + classeLocation}>Partenaires officiels</span>
                    <div className="footer_logos_row">
                        <img src={logoMinistere} onClick={()=>openWindow('https://www.sports.gouv.fr/')} />
                        <img src={logoANS} onClick={()=>openWindow('https://www.agencedusport.fr/')} />
                        <img src={logoCreditMutuel} onClick={()=>openWindow('https://www.creditmutuel.fr/')} />
                        <img src={logoTibhar} onClick={()=>openWindow('https://tibhar.info/fr/')} />
                        <img src={logoCornilleau} onClick={()=>openWindow('https://fr.cornilleau.com/')} />
                        <img src={leapmotor} onClick={()=>openWindow('https://www.leapmotor.net')} />
                        <img src={logoNittaki} onClick={()=>openWindow('https://www.donic.com/donic/fr')} />
                        <img src={logoGerflor} onClick={()=>openWindow('https://www.gerflor.fr/')} />
                    </div>
                </div>
                <div className="footer_details">
                    <ul className="footer-menu">
                        <li>
                            <a href="">Copyright FFTT PRO 2026</a>
                        </li>
                        <li>
                            <a href="https://www.fftt.com/site/articles/mentions-legales">Mentions légales</a>
                        </li>
                        <li>
                            <a href="https://www.fftt.com/site/contactez-nous">Contact</a>
                        </li>
                        <li>
                            <a href="https://www.fftt.com/site/">fftt.com</a>
                        </li>
                        <li>
                            <NavLink to="/docs">Documentation</NavLink>
                        </li>
                    </ul>                   
                </div>
            </div>
        </div>
    );
}

export default Footer;
